import OncePerIterationRemark from './OncePerIterationRemark';

class OnceADayGroupRemark extends OncePerIterationRemark {
    OtherNomenclatureNumber: string;
    OtherProcedureCode: string;

    info(t: Function): React.ReactElement {
        return (
            <p>
                {t('Nomenclature')}
                {' '}
                {this.NomenclatureNumber}
                {' '}
                {t('From')}
                {' '}
                {t('Procedure')}
                {' '}
                {this.ProcedureCode}
                {' '}
                {t('CanNotBeAdded')}
                .
                {t('HadGroupNomenclature')}
                {' '}
                {t('NomenclatureGroupRestrictionDay')}
                {' '}
                <a href={`~/Orders/Detail/${this.OrderID}`} className="ajaxLinkNav">{t('Order')} #{this.OrderID}</a>
                {' '}
                (
                <a href={`~/Invoices/DetailConfirmed/${this.InvoiceID}`} className="ajaxLinkNav">{t('Invoice')} #{this.InvoiceID}</a>
                ).
                {t('Nomenclature')}
                {' '}
                {this.OtherNomenclatureNumber}
                {' '}
                {t('From')}
                {' '}
                {t('Procedure')}
                {' '}
                {this.OtherProcedureCode}
            </p>
        );
    }

    constructor(nomenclatureNumber: string, procedureCode: string, date: Date, perIteration: number, orderID: number, invoiceID: number, otherNomenclatureNumber: string, otherProcedureCode: string) {
        super(nomenclatureNumber, procedureCode, date, perIteration, orderID, invoiceID);
        this.OtherNomenclatureNumber = otherNomenclatureNumber;
        this.OtherProcedureCode = otherProcedureCode;
    }
}

export default OnceADayGroupRemark;
